import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { plainToClass } from 'class-transformer';
import { Elaboration } from 'app/shared/models/elaboration.model';
import { EntityType } from 'app/shared/models/entity-id-details.model';

/**
 * Service for Monitoring Elaboration Descriptions update.
 */
@Injectable()
export class ElaborationService {

    constructor(private requestService: ObservableRequestService) { }

    // Get Elaboration Description Text.
    getElaborationDesc(entityId: number, entityType: EntityType): Observable<any> {
        const elaborationDescUri = ConstantsService.MONITORING_ELABORATION_INFO_SERVICES + '/' + entityId;
        return this.requestService.getRequest(elaborationDescUri).map(response => {
            return plainToClass(Elaboration, response.arrResult as Object[]);
        });
    };

    // Method to update Elaboration Description Text using text editor.
    updateElaborationDescription(elaborationTextSaveData: Elaboration, entityId: number): Observable<any> {
        const elaborationSaveUri = ConstantsService.MONITORING_ELABORATION_INFO_SERVICES;
        return this.requestService.putRequest(
            elaborationSaveUri + '/' + entityId,
            this.requestService.serialize(elaborationTextSaveData),
            this.requestService.getFormEncodedContentType());
    };
}


// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/elaboration/elaboration.service.ts